import golfBadge from "@/assets/golf-classic-badge-transparent.png";

export const LOGO = golfBadge;

// ─────────────────────────────────────────────────────────────
// PAYMENTS TOGGLE
// Set PAYMENTS_ENABLED to `true` to activate live Stripe checkout
// for Registration and Sponsorships. While `false`, both CTAs
// simply open a pre-filled email to INQUIRY_EMAIL instead.
// (Backend Stripe endpoints are already built — no code changes
//  needed beyond flipping this flag.)
// ─────────────────────────────────────────────────────────────
export const PAYMENTS_ENABLED = true;
// Per-flow live Stripe checkout toggles. When true, the form offers
// "Pay by card (Stripe)" alongside "Pay by check / invoice".
export const PAYMENTS = { registration: true, donation: true, sponsorship: true };
export const INQUIRY_EMAIL = "kyle@waynewalkerfoundation.org";
export const FOUNDATION_URL = "https://waynewalkerfoundation.org";
export const FOUNDATION_DOMAIN = "waynewalkerfoundation.org";

// Set to `true` when sponsorship pricing & benefit details are finalized.
// While `false`, prices/perks are blurred on the site and shown as
// "Coming Soon" on the flyer — the tiers and inquiry CTAs stay visible.
export const SPONSOR_DETAILS_VISIBLE = true;

export const EVENT = {
  name: "The Heroes & Legacy Golf Classic",
  edition: "Inaugural Edition",
  location: "Montgomery County, Texas",
  dateLabel: "April 8, 2027",
  dayLabel: "Thursday · 9:00 AM Shotgun Start",
  venue: "The Woodlands Country Club",
  venueCourse: "The Trails",
  venueSub: "The Trails · Spring, Texas",
  venueNote: "The Trails · 2311 N Millbend Dr, Spring, TX 77380",
  address: "2311 N Millbend Dr, Spring, TX 77380",
  teams: "36 Teams",
  teamsSub: "144 players · four-person scramble",
  beneficiary: "Wayne Walker Foundation",
};

export const IMAGES = {
  heroGolf:
    "https://images.unsplash.com/photo-1709525617656-5498eefc7d03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxnb2xmJTIwY291cnNlJTIwbW9ybmluZ3xlbnwwfHx8fDE3ODM2MjM3OTN8MA&ixlib=rb-4.1.0&q=85",
  texasSunset:
    "https://images.unsplash.com/photo-1683836018144-6e5f398102de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxnb2xmJTIwY291cnNlJTIwZmFpcndheSUyMHRleGFzJTIwc3Vuc2V0fGVufDB8fHx8MTc4MzYyMzkxMHww&ixlib=rb-4.1.0&q=85",
  firefighterPortrait:
    "https://images.unsplash.com/photo-1618609252884-c29e29b32205?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxmaXJlZmlnaHRlcnMlMjBzcHJheWluZyUyMHdhdGVyJTIwYnVybmluZyUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MzYzNDg3OXww&ixlib=rb-4.1.0&q=85",
  firefighterSmoke:
    "https://images.unsplash.com/photo-1606613817011-84d20b0959ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxmaXJlJTIwdHJ1Y2slMjBmaXJlZmlnaHRlcnMlMjBjb21tdW5pdHl8ZW58MHx8fHwxNzgzNjIzOTEwfDA&ixlib=rb-4.1.0&q=85",
  fireStation:
    "https://images.unsplash.com/photo-1583960222449-0499d11a3dba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxmaXJlJTIwdHJ1Y2slMjBmaXJlZmlnaHRlcnMlMjBjb21tdW5pdHl8ZW58MHx8fHwxNzgzNjIzOTEwfDA&ixlib=rb-4.1.0&q=85",
  golferSwing:
    "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxnb2xmZXJzJTIwZ29sZiUyMHRvdXJuYW1lbnQlMjBzY3JhbWJsZXxlbnwwfHx8fDE3ODM2MjM5MTB8MA&ixlib=rb-4.1.0&q=85",
  golfBallHole:
    "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxnb2xmZXJzJTIwZ29sZiUyMHRvdXJuYW1lbnQlMjBzY3JhbWJsZXxlbnwwfHx8fDE3ODM2MjM5MTB8MA&ixlib=rb-4.1.0&q=85",
  trophies:
    "https://images.unsplash.com/photo-1514820720301-4c4790309f46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxnb2xmJTIwdHJvcGh5JTIwYXdhcmRzJTIwY2VyZW1vbnl8ZW58MHx8fHwxNzgzNjIzOTEwfDA&ixlib=rb-4.1.0&q=85",
  vintageClubs:
    "https://images.unsplash.com/photo-1592967449177-d88a95223c86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwZ29sZiUyMGNsdWJzfGVufDB8fHx8MTc4MzYyMzc5NHww&ixlib=rb-4.1.0&q=85",
  ffTeam:
    "https://images.unsplash.com/photo-1638401607229-31dbd79b5b37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxmaXJzdCUyMHJlc3BvbmRlciUyMHJlc2N1ZSUyMHRlYW18ZW58MHx8fHwxNzgzODUxOTEzfDA&ixlib=rb-4.1.0&q=85",
  responderGroup:
    "https://images.unsplash.com/photo-1649260257572-91bf6f94cff6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxmaXJzdCUyMHJlc3BvbmRlciUyMHJlc2N1ZSUyMHRlYW18ZW58MHx8fHwxNzgzODUxOTEzfDA&ixlib=rb-4.1.0&q=85",
  policeService:
    "https://images.pexels.com/photos/7714759/pexels-photo-7714759.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  emsMedic:
    "https://images.pexels.com/photos/6519887/pexels-photo-6519887.jpeg",
  ffCrew:
    "/ff-flag-raise.jpg",
};

export const DAY_INCLUDES = [
  "Breakfast & on-course food",
  "Player gift bag & branded apparel",
  "Hole-in-one · longest drive · closest-to-pin",
  "Silent auction",
  "Awards reception & remarks",
  "Recognition of our first responders",
];

export const SCHEDULE = [
  { time: "7:30 AM", title: "Registration & Check-In", desc: "Registration opens — breakfast, driving range warm-up, and gift bag pickup." },
  { time: "9:00 AM", title: "Shotgun Start", desc: "Four-person scramble across all 18 holes." },
  { time: "2:00 PM", title: "Post-Golf Reception, Lunch & Awards", desc: "Lunch served, team awards, and recognition of our first responders." },
];

export const SPONSOR_DEADLINES = {
  foundingDate: "December 31, 2026",
  foundingText: "Commit by December 31, 2026 to be recognized permanently as a Founding Partner on the website and in the event program.",
  commitDate: "February 15, 2027",
  commitText: "Commit by February 15, 2027 to guarantee signage, program listing, and gift-bag inclusion.",
};

// Default spots per level — editable live in the Admin dashboard (Sponsor Setup).
export const SPONSOR_CAPACITY_DEFAULTS = { legacy: 1, impact: 3, courage: 5, honor: 8, service: 10, tribute: 12 };

// Default activation sponsorships — prices editable in the Admin dashboard.
export const ACTIVATION_DEFAULTS = [
  { key: "golf_cart", label: "Golf Cart Sponsor", amount: 5000, desc: "Your brand rides on every cart, all day." },
  { key: "beverage_cart", label: "Beverage Cart Sponsor", amount: 3500, desc: "The most-welcomed brand on the course — roaming all 18 holes." },
  { key: "breakfast", label: "Breakfast Sponsor", amount: 2500, desc: "Welcome every player to the day." },
  { key: "lunch", label: "Lunch Sponsor", amount: 3500, desc: "Own the reception meal where the day is celebrated." },
  { key: "awards_reception", label: "Awards Reception Sponsor", amount: 3000, desc: "Present the trophies and the podium moment." },
  { key: "driving_range", label: "Driving Range Sponsor", amount: 2000, desc: "Where every round — and impression — begins." },
  { key: "putting_green", label: "Putting Green Sponsor", amount: 1500, desc: "Prime, high-traffic warm-up visibility." },
];
export const IN_KIND_NOTE = "In-kind contributions (products, services, or supplies) are welcome toward any activation — let's talk.";

// What every activation sponsor receives, in addition to the activation itself.
export const ACTIVATION_INCLUDES = "Every activation sponsor receives branded signage at the activation plus recognition in the event program and on the website.";

// Founding Partner program — one canonical benefit set. Condition must always be stated.
export const FOUNDING_PARTNER = {
  condition: "Commit by December 31, 2026.",
  benefits: [
    { title: "Permanent Recognition", desc: "Named a Founding Partner on the website and in every program, every year." },
    { title: "Priority Renewal Invitation", desc: "First invitation to renew your level before it is offered publicly." },
    { title: "Legacy Status", desc: "Honored as an inaugural partner for the life of the event." },
    { title: "Founding Wall Placement", desc: "Your name on the Founding Partners wall at the event and online." },
  ],
};

// Canonical benefits matrix — the single source for the prospectus (p15) and flyer "Benefits at a Glance".
// true = ✓, false = —, string = text value.
export const MATRIX_COLUMNS = [
  { key: "legacy", name: "Legacy", price: 30000 },
  { key: "impact", name: "Impact", price: 15000 },
  { key: "courage", name: "Courage", price: 10000 },
  { key: "honor", name: "Honor", price: 7500 },
  { key: "service", name: "Service", price: 5000 },
  { key: "tribute", name: "Hero Team", price: 2500 },
];
export const BENEFITS_MATRIX = [
  { label: "Players", values: ["2 foursomes (8)", "1 foursome (4)", "1 foursome (4)", "2 golfers", false, "Sponsored first responder team"] },
  { label: "Logo / signage", values: ["Premier", "Prominent", "Logo on recognition board", "Logo on recognition board", "Name on board", "Logo on team cart + board"] },
  { label: "Hole sign", values: [true, true, true, true, true, false] },
  { label: "Event program", values: ["Full page", "1/2 page", "1/4 page", "Recognition", "Recognition", "Recognition"] },
  { label: "Website", values: ["Logo", "Logo", "Logo", "Listing", "Listing", "Recognition"] },
  { label: "Social media", values: ["Premier recognition", "Premium recognition", "Recognition", "Recognition", "Post-event recognition", "Before & after event"] },
  { label: "Booth / display space", values: [true, true, false, false, false, false] },
  { label: "Ceremony recognition", values: ["Welcome remarks + awards", "Opening & closing", "Awards", false, false, "Opening + awards"] },
  { label: "Gift-bag promo items", values: [true, true, true, true, false, "Thank-you note / small gift for its team"] },
  { label: "VIP hospitality / reserved seating", values: [true, false, false, false, false, false] },
  { label: "Renewal", values: ["First right of renewal", "Priority renewal", false, false, false, false] },
  { label: "Founding Partner", values: Array(6).fill("✓ if committed by Dec 31, 2026") },
];

export const SPONSOR_TIERS = [
  {
    key: "legacy",
    name: "Legacy",
    price: 30000,
    highlight: true,
    availability: "Exclusive Presenting Sponsor · 1 Available",
    theme: "Creating a lasting impact that extends beyond the tournament.",
    perks: [
      "Exclusive Presenting Sponsor designation",
      "Event branding: Wayne Walker Foundation Heroes & Legacy Golf Classic presented by [Company]",
      "Two complimentary foursomes (8 golfers)",
      "Premium hole sponsorship",
      "Opportunity to deliver welcome remarks during the opening ceremony",
      "Premier logo placement on all event signage, website, marketing materials, and social media",
      "Premium recognition throughout the event",
      "Full-page recognition in the event program",
      "Logo featured on a player gift item (if applicable)",
      "VIP hospitality and reserved seating",
      "Booth/display space at registration or the clubhouse",
      "Opportunity to include promotional items in every player gift bag",
      "Recognition during the awards ceremony",
      "First right of renewal for the following year's tournament",
    ],
  },
  {
    key: "impact",
    name: "Impact",
    price: 15000,
    theme: "Making a direct and lasting difference for those who serve.",
    perks: [
      "One complimentary foursome (4 golfers)",
      "Prominent logo placement on tournament signage",
      "Premium recognition on the event website and social media",
      "Half-page recognition in the event program",
      "Premium hole sponsorship",
      "Opportunity to include promotional items in player gift bags",
      "Booth/display opportunity",
      "Recognition during opening and closing ceremonies",
      "Priority renewal opportunity",
    ],
  },
  {
    key: "courage",
    name: "Courage",
    price: 10000,
    featured: true,
    badge: "Most Popular",
    theme: "Honoring those who answer the call despite uncertainty.",
    perks: [
      "One complimentary foursome (4 golfers)",
      "Premium hole sponsorship",
      "Logo displayed on sponsor recognition board",
      "Logo featured on the event website",
      "Quarter-page recognition in the event program",
      "Social media recognition",
      "Opportunity to include promotional items in player gift bags",
      "Recognition during the awards ceremony",
    ],
  },
  {
    key: "honor",
    name: "Honor",
    price: 7500,
    theme: "Celebrating integrity, commitment, and service.",
    perks: [
      "Two golfer registrations",
      "Hole sponsorship with custom signage",
      "Company logo on sponsor recognition board",
      "Listing on the event website",
      "Recognition in the printed event program",
      "Social media recognition",
      "Opportunity to provide promotional items for player gift bags",
    ],
  },
  {
    key: "service",
    name: "Service",
    price: 5000,
    theme: "Supporting those who dedicate themselves to protecting our communities.",
    perks: [
      "Hole sponsorship with custom signage",
      "Company name listed on the sponsor recognition board",
      "Recognition in the event program",
      "Listing on the event website",
      "Post-event sponsor recognition on social media",
    ],
  },
];

export const TRIBUTE_TIER = {
  key: "tribute",
  name: "Sponsor a Hero Team",
  shortName: "Hero Team",
  price: 2500,
  theme: "Honoring those who serve by sponsoring a first responder team's day on the course.",
  photoOp: "Includes a professional team photo op with your sponsored first responders — yours to share.",
  gridHighlights: [
    "Sponsors one four-person first responder team",
    "Full team tournament experience covered",
    "Recognition on the team cart, website, program & social",
    "Professional team photo op with your sponsored heroes",
  ],
  headline: "Sponsor a Hero Team. Honor Those Who Serve.",
  intro1:
    "Not every sponsorship is about promoting your business. This unique opportunity allows your organization to directly sponsor the participation of one four-person team of local first responders, ensuring they are recognized as honored guests during the Heroes & Legacy Golf Classic.",
  intro2:
    "Your sponsorship celebrates the dedication and sacrifice of firefighters, law enforcement officers, EMS professionals, and emergency dispatchers while providing them with a memorable day of appreciation, camaraderie, and community recognition.",
  groups: [
    {
      id: "recognition",
      title: "Sponsor Recognition",
      items: [
        "Official recognition as a Hero Team Sponsor",
        "Company logo displayed on your sponsored team's golf cart",
        "Recognition on the tournament website",
        "Recognition in the printed event program",
        "Recognition on the event sponsor board",
        "Social media recognition before and after the tournament",
        "Recognition during the opening ceremony and awards presentation",
      ],
    },
    {
      id: "support",
      title: "Support for Your Sponsored Team",
      lead: "Your sponsorship covers:",
      items: [
        "Registration for one four-person first responder team",
        "Green fees and golf carts",
        "Breakfast and lunch",
        "Player gift bags",
        "Tournament contests and activities",
        "Awards reception",
      ],
    },
    {
      id: "experience",
      title: "Exclusive Experience",
      items: [
        "Meet your sponsored team before the shotgun start",
        "Professional team photograph with your sponsored first responder team",
        "Opportunity to include a personalized thank-you note or small branded gift in their player gift bags (subject to event guidelines)",
      ],
    },
    {
      id: "post",
      title: "Post-Event Recognition",
      items: [
        'Digital "Proud Hero Team Sponsor" badge',
        "Team photograph for your company's marketing and social media",
        "Recognition in the Foundation's post-event impact report",
      ],
    },
  ],
  calloutTitle: "Your Sponsorship Makes an Immediate Impact",
  callout:
    "By sponsoring a Hero Team, your company ensures that those who dedicate their lives to protecting our communities are celebrated and recognized with a first-class tournament experience — and you take home a professional team photo with the heroes you honored. This sponsorship creates one of the most meaningful opportunities available — because your support directly honors those who serve.",
};

export const CONTACT = {
  sponsorEmail: "kyle@waynewalkerfoundation.org",
  sponsorPhone: "(713) 725-7413",
  registerEmail: "kyle@waynewalkerfoundation.org",
  website: "hlgolfclassic.com",
  social: "WWalkerFDN",
};

export const DONATION = {
  presets: [25, 50, 100, 250],
  blurb:
    "Not playing or sponsoring? You can still make a direct impact. Every dollar supports the Wayne Walker Foundation and the first responders who serve our community.",
};
